module.exports = __webpack_public_path__ + "media/images/file-text-07eddee2d221534b55eb2c55aab59356.svg";